import React from 'react';
import { Tooltip, TooltipProps } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

const TippyTooltip = Tooltip as React.ComponentType<
  TooltipProps & { children: React.ReactNode }
>;

import { Plan, PLAN_HIERARCHY } from 'modules/subscription';
import sailsImage from 'modules/ui/assets/images/Sails.png';

import {
  Container,
  SailsImage,
  TooltipBody,
  UpgradeLink,
} from './styledComponents';

type Props = {
  minimumPlan?: Plan;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
};

// TODO: Connect to Redux store
const userPlan = Plan.Unlimited;

const Paywall: React.FC<Props> = ({
  minimumPlan = Plan.Free,
  placement = 'top',
  children,
}) => {
  const isLocked = PLAN_HIERARCHY[userPlan] < PLAN_HIERARCHY[minimumPlan];

  const tooltipContent = (
    <TooltipBody>
      <SailsImage src={sailsImage} alt="Sails" />
      Requires {minimumPlan} plan.{' '}
      <UpgradeLink href="/upgrade">Upgrade</UpgradeLink>
    </TooltipBody>
  );

  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <TippyTooltip
      html={tooltipContent}
      position={placement}
      trigger="mouseenter"
      interactive
      theme="transparent"
      animateFill={false}
      disabled={!isLocked}
    >
      <Container isLocked={isLocked}>{children}</Container>
    </TippyTooltip>
  );
};

export default React.memo(Paywall);
